<div class="modal-header ai-modal-header">
  <div class="ai-modal-title">
    <i class="las la-robot ai-icon"></i>
    <h4 class="modal-title">{{ 'ai.title' | translate }}</h4>
  </div>
  <div class="ai-header-actions">
    <button *ngIf="selectedOption" class="btn btn-sm btn-outline-light mr-2" (click)="goBack()">
      <i class="las la-arrow-left"></i> {{ 'ai.back' | translate }}
    </button>
    <button type="button" class="close" (click)="close()">
      <span>&times;</span>
    </button>
  </div>
</div>

<div class="modal-body ai-modal-body">

  <!-- SELECTOR DE ANÁLISIS -->
  <div *ngIf="!selectedOption" class="ai-options-container">
    <p class="ai-prompt-text">{{ 'ai.selectPrompt' | translate }}</p>
    <div class="ai-options-grid">
      <div
        *ngFor="let opt of options"
        class="ai-option-card"
        (click)="selectOption(opt)"
      >
        <i class="{{ opt.icon }} ai-option-icon"></i>
        <div class="ai-option-label">{{ opt.label | translate }}</div>
        <div class="ai-option-desc">{{ opt.description | translate }}</div>
      </div>
    </div>
  </div>

  <!-- RESULTADO / STREAMING -->
  <div *ngIf="selectedOption" class="ai-result-container">
    <div class="ai-result-header">
      <i class="{{ selectedOption.icon }}"></i>
      <span>{{ selectedOption.label | translate }}</span>
    </div>

    <div *ngIf="selectedOption.key === 'custom' && !isStreaming && !rawMarkdown" class="ai-custom-query">
      <p class="ai-custom-label">¿Qué querés saber sobre los datos DLP?</p>
      <textarea
        class="form-control ai-custom-textarea"
        [(ngModel)]="customPrompt"
        placeholder="Ej: ¿Qué usuarios están enviando datos a Gmail? ¿Hay algún patrón sospechoso en los últimos 30 días?"
        rows="4"
        (keydown.enter)="onCustomKeydown($event)"
      ></textarea>
      <button class="btn btn-primary mt-2 w-100" [disabled]="!customPrompt.trim()" (click)="runAnalysis()">
        <i class="las la-paper-plane"></i> Consultar
      </button>
      <small class="text-muted mt-1 d-block">Enter para enviar · Shift+Enter para nueva línea</small>
    </div>

    <div class="ai-result-body">
      <div *ngIf="isStreaming && !rawMarkdown" class="ai-loading">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
        <span class="ml-2">{{ 'ai.analyzing' | translate }}</span>
      </div>

      <div
        *ngIf="rawMarkdown"
        class="ai-rendered-content"
        [innerHTML]="renderedHtml"
      ></div>

      <span *ngIf="isStreaming" class="ai-cursor">▋</span>
    </div>

    <div *ngIf="isDone" class="ai-result-footer">
      <button class="btn btn-outline-primary btn-sm" (click)="runAnalysis()">
        <i class="las la-redo"></i> {{ 'ai.rerun' | translate }}
      </button>
      <button class="btn btn-outline-danger btn-sm ml-2" (click)="exportPdf()">
        <i class="las la-file-pdf"></i> Exportar PDF
      </button>
    </div>
  </div>

</div>
